let getTokenFn = null;

export const setGetToken = (fn) => {
  getTokenFn = fn;
};

export const getFreshToken = async () => {
  if (!getTokenFn) return null;
  return await getTokenFn({ skipCache: true });
};
